import { ROLLING_OVERLAP_DAYS, ROLLING_TIME_RANGE } from "@repo/adapter-core/date-window";

/**
 * Recurring-job presets. Each one sets the cron (UTC, as pg_cron reads it) and a
 * rolling "since-last-success" window, so a run crawls only the period since the
 * job's last completed run. 16:00 UTC is 2-3am in Melbourne the next day.
 */
export const CADENCE_PRESETS = {
  weekly: {
    label: "Weekly",
    cron: "0 16 * * 0",
    firstRunDays: 7,
    when: "Mondays, about 2-3am Melbourne time",
  },
  monthly: {
    label: "Monthly",
    cron: "0 16 1 * *",
    firstRunDays: 31,
    when: "the 2nd of each month, about 2-3am Melbourne time",
  },
} as const;

export type Cadence = keyof typeof CADENCE_PRESETS | "custom";

export function cadenceForCron(cron: string | null | undefined): Cadence {
  const trimmed = cron?.trim();
  for (const [cadence, preset] of Object.entries(CADENCE_PRESETS)) {
    if (preset.cron === trimmed) return cadence as Cadence;
  }
  return "custom";
}

export function describeCadence(cadence: Exclude<Cadence, "custom">): string {
  const preset = CADENCE_PRESETS[cadence];
  return `Runs ${preset.when}. Each run crawls sales since the last successful run, with ${ROLLING_OVERLAP_DAYS} days' overlap; the first run covers the last ${preset.firstRunDays} days.`;
}

/** Job config fields a preset sets: the rolling window and its first-run length. */
export function cadenceDateConfig(cadence: Exclude<Cadence, "custom">) {
  return {
    dateFilterMode: "relative" as const,
    timeRange: ROLLING_TIME_RANGE,
    rollingFirstRunDays: CADENCE_PRESETS[cadence].firstRunDays,
    dateFrom: undefined,
    dateTo: undefined,
  };
}
